var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.81 24.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7.02c10.61-.51,17.04,11.68,10.42,20.1-5.75,7.32-17.17,5.91-21.01-2.54C-2.49,9.66,3.07.44,11.7.02ZM12.12,1.6C3.54,1.85-1.42,11.59,3.57,18.68c4.44,6.31,13.87,6.04,17.96-.49,4.34-6.95-.32-15.98-8.4-16.56l-1.01-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1,16.87h-2.35c-.04-1.28.05-2.58,0-3.85-.03-.81-.09-1.79-1.11-1.87-1.09-.08-1.48.61-1.54,1.6v4.12h-2.38v-7.63h2.27v1.05c.4-.62,1-1.07,1.74-1.2,1.93-.34,3.26.73,3.35,2.69.06,1.69.01,3.39.03,5.09h-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.86,
    y: 9.24,
    width: 2.38,
    height: 7.63
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05,5.45c1.88,0,1.79,2.9-.13,2.75-1.67-.13-1.63-2.75.13-2.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.11a963d607403c360c80b4a2eff63a11.svg";
export { ForwardRef as ReactComponent };